// App.tsx
import React from "react";
import Menu from "./Components/Menu/Menu";
import Footer from "./Components/Footer/Footer";
import ComponenteInferior from "./Components/ComponenteInferior";
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import './App.css'
import CreacionTexto from "./Components/CreacionTexto";
import PostPlanner from "./Components/PostPlanner";
import Perfil from "./Components/Perfil/Perfil";
import HomeScreen from "./Components/HomeScreen";
import PasswordRecovery from "./Components/PasswordRecovery";
import DoneScreen from "./Components/DoneScreen";
import Drafts from './Components/Perfil/Drafts';  // Adjust the path accordingly
import ImageCreationChoice from './Components/ImageCreationChoice';
import ComponenteCarousel from "./Components/Carrusel/ComponenteCarousel";
import ComponenteCarousel2 from "./Components/Carrusel/ComponenteCarousel2";
import ComponenteCarousel3 from "./Components/Carrusel/ComponenteCarousel3";
import ComponenteReel from "./Components/Reel/ComponenteReel";
import ComponenteReel2 from "./Components/Reel/ComponenteReel2";
import ComponenteReel3 from "./Components/Reel/ComponenteReel3";
import { Helmet } from 'react-helmet';
import './Components/Scrollbar.css'; // Importa el archivo CSS con los estilos de la barra de desplazamiento
import ComponenteAvatar from "./Components/Avatar/ComponenteAvatar";
import ComponenteAvatar4 from "./Components/Avatar/ComponenteAvatar4";
import ComponenteAvatar2 from "./Components/Avatar/ComponenteAvatar2";
import ComponenteAvatar3 from "./Components/Avatar/ComponenteAvatar3";
import WebSocketComponent from "./WebSocketComponent";
import AvatarChoiceSelector from "./Components/Avatar/AvatarChoiceSelector";
import PantallaInicial from "./Components/PantallaInicial/PantallaInicial";
import ComponenteWeb from "./Components/Web/ComponenteWeb";
import LandingPageResult from "./Components/Web/LandingPageResult";
import LandingEdition from "./Components/Web/LandingEdition";
import VideoCreativo from "./Components/VideoCreativo/ComponenteVideoCreativo";
import VideoCreativo2 from "./Components/VideoCreativo/ComponenteVideoCreativo2";
import VideoCreativo3 from "./Components/VideoCreativo/ComponenteVideoCreativo3";
import CheckoutPage from "./Components/CheckoutPage/CheckoutPage";
import { Analytics } from "@vercel/analytics/react"
import { GoogleOAuthProvider } from '@react-oauth/google';  // Importa el GoogleOAuthProvider
import ComponenteWeb2 from "./Components/Web/ComponenteWeb2";

const clientId = '980339180622-hs0713eeb4keijdnijdm53fon80vve9r.apps.googleusercontent.com';

const App: React.FC = () => {
  return (
    <GoogleOAuthProvider clientId={clientId}>
    <div id="root">
            <Helmet>
        <link rel="icon" href="%PUBLIC_URL%/LogoTaapt.svg" type="image/svg+xml" />
      </Helmet>
      <Router>
        <div className="main-content">
          <Menu />
          <Switch>
            <Route exact path="/" component={HomeScreen} />
            <Route path="/Social-Networking" component={ComponenteInferior} />
            <Route path="/Social-Networking2" component={CreacionTexto} />
            <Route path="/Social-Networking3" component={PostPlanner} />
            <Route path="/Social-Networking-Carousel" component={ComponenteCarousel} />
            <Route path="/Social-Networking-Carousel2" component={ComponenteCarousel2} />
            <Route path="/Social-Networking-Carousel3" component={ComponenteCarousel3} />
            <Route path="/Social-Networking-Reel" component={ComponenteReel} />
            <Route path="/Social-Networking-Reel2" component={ComponenteReel2} />
            <Route path="/Social-Networking-Reel3" component={ComponenteReel3} />
            <Route path="/Social-Networking-Avatar" component={ComponenteAvatar} />
            <Route path="/Social-Networking-Avatar2" component={ComponenteAvatar2} />
            <Route path="/Social-Networking-Avatar3" component={ComponenteAvatar3} />
            <Route path="/Social-Networking-Avatar4" component={ComponenteAvatar4} />
            <Route path="/PantallaInicial" component={PantallaInicial}/>
            <Route path="/PerfilPage" component={Perfil} />
            <Route path="/PasswordRecovery" component={PasswordRecovery}/>
            <Route path="/FinalScreen" component={DoneScreen}/>
            <Route path="/drafts" component={Drafts} />
            <Route path="/ImageCreationChoice"  component={ImageCreationChoice} />
            <Route path="/AvatarChoiceSelector"  component={AvatarChoiceSelector} />
            <Route path="/Avatar" component={ComponenteAvatar} />
            <Route path="/Avatar2" component={WebSocketComponent} />
            <Route path="/Web" component={ComponenteWeb} />
            <Route path="/LandingResult" component={ComponenteWeb2} />
            <Route path="/LandingEdition" component={LandingEdition} />
            <Route path="/VideoCreativo" component={VideoCreativo} />
            <Route path="/VideoCreativo2" component={VideoCreativo2} />
            <Route path="/VideoCreativo3" component={VideoCreativo3} />
            <Route path="/CheckoutPage" component={CheckoutPage} />

          </Switch>
          <Analytics/>
        </div>
        <div className="footer" >
        <Footer />
        </div>
      
      </Router>
    </div>
    </GoogleOAuthProvider>
  );
};

export default App;
